import type { AnalyticsStatsView } from '~/hooks/queries/useAnalyticsStatsViewsQuery';
import { scopeToTopLevel, type ScopeBucket } from './analyticsStatsConstants';

export const CUSTOM_REPORTS_SCOPE_PARAM = 'customScope';

export type CustomReportsScopeFilter = 'all' | 'mine' | 'account';

export function parseCustomReportsScopeFilter(
  param: string | null | undefined,
): CustomReportsScopeFilter {
  if (param === 'mine' || param === 'account') return param;
  return 'all';
}

export function matchesCustomReportsScopeFilter(
  view: AnalyticsStatsView,
  filter: CustomReportsScopeFilter,
): boolean {
  if (filter === 'all') return true;
  const topLevel = scopeToTopLevel[(view.scopeBucket ?? 'other') as ScopeBucket];
  if (filter === 'mine') return topLevel === 'user';
  return topLevel === 'account';
}

export function customReportsGridColumnsForScope(filter: CustomReportsScopeFilter): {
  showAccounts: boolean;
  showUserAccess: boolean;
  showCreated: boolean;
  showModified: boolean;
} {
  if (filter === 'all') {
    return {
      showAccounts: true,
      showUserAccess: true,
      showCreated: true,
      showModified: true,
    };
  }
  return {
    showAccounts: true,
    showUserAccess: false,
    showCreated: true,
    showModified: true,
  };
}
